import {
  faHandHoldingDollar,
  faUsersLine,
  faBuildingColumns,
  faCartShopping,
  faChartLine,
  faChartPie,
  faChartSimple,
  faCreditCard,
  faGear,
  faGears,
  faMoneyBillTransfer,
  faUser,
  faMoneyBill,
  faMoneyCheckDollar,
  faUnlockKeyhole
} from "@fortawesome/free-solid-svg-icons";
import { CustomRouter } from "../model/custom-router.model";

export const MENU: CustomRouter[] = [
  {
    to: "/",
    text: "Inicio",
    icon: faChartPie,
  },
  // {
  //     to: '/activity',
  //     text: 'Actividad',
  //     icon: faChartSimple
  // },
  {
    to: "/transacciones",
    text: "Transacciones",
    icon: faCreditCard,
  },
    {
    to: "/transferencias-bancarias",
    text: "Transferencias",
    icon: faMoneyBillTransfer,
  },
  {
    to: "/transferencias/retiros",
    text: "Retiros",
    icon: faMoneyBill,
  },
  {
    to: "/transferencias/historial",
    text: "Historial de retiros",
    icon:   faHandHoldingDollar,
  },
  {
    to: "/transferencias/cuentas",
    text: "Cuentas",
    icon: faBuildingColumns,
  },

  //   {
  //     to: "/transference/withdrawals",
  //     text: "Dispersiones",
  //     icon: faMoneyBillTransfer,
  //     children: [
  //       { to: "/transference/withdrawals", text: "Retiros", icon: faMoneyBill },
  //       { to: "/transference/clients", text: "Clientes", icon: faUsersLine },
  //       {
  //         to: "/transference/history",
  //         text: "Historial",
  //         icon: faHandHoldingDollar,
  //       },

  //       {
  //         to: "/transference/accounts",
  //         text: "Cuentas",
  //         icon: faMoneyCheckDollar,
  //       },
  //     ],
  //   },
  // {
  //     to: '/bankaccount',
  //     text: 'Cuentas bancarias',
  //     icon: faBuildingColumns
  // },

  // {
  //     to: '/transfer',
  //     text: 'Retiros',
  //     icon: faCartShopping
  // },
  // {
  //     to: '/products',
  //     text: 'Productos',
  //     icon: faBagShopping
  // },
  // {
  //     to: '/sales-report',
  //     text: 'Reporte de ventas',
  //     icon: faChartLine
  // },
  // {
  //     to: '/messages',
  //     text: 'Mensajes',
  //     icon: faCommentDots
  // },

    {
    to: "/tarjetas",
    text: "Bloquear tarjetas",
    icon: faUnlockKeyhole,
  },
  {
    to: "/perfil",
    text: "Mi perfil",
    icon: faUser,
  },
  // {
  //     to: '/credentials',
  //     text: 'Credenciales',
  //     icon: faAddressCard
  // },
  {
    to: "/integraciones",
    text: "Integraciones",
    icon: faGears,
  },
  // {
  //   to: "/configuraciones",
  //   text: "Configuraciones",
  //   icon: faGear,
  // },
  // {
  //     text: 'Sign Out',
  //     icon: faRightFromBracket,
  //     click: handleLogout
  // }
];
